import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";
import { CALCULATOR_LIST } from "../lib/calculators";

const linkClass =
  "group pct-panel flex items-center gap-3 rounded-xl px-3.5 py-3 text-sm font-medium transition-all hover:border-primary/50 hover:bg-primary/[0.08]";
const iconChip =
  "pct-chip grid h-9 w-9 shrink-0 place-items-center rounded-lg text-base";

/**
 * Internal links to the other calculators (and back to the hub). Keeps the
 * cluster tightly interlinked for both users and crawlers.
 */
export function RelatedCalculators({ currentSlug }: { currentSlug?: string }) {
  const others = CALCULATOR_LIST.filter((c) => c.slug !== currentSlug);
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.pct_related_title()}
      </h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {currentSlug !== undefined && (
          <Link to="/percentage-calculator" className={linkClass}>
            <span aria-hidden className={iconChip}>
              🧮
            </span>
            <span>{m.pct_nav_basic()}</span>
          </Link>
        )}
        {others.map((c) => (
          <Link
            key={c.slug}
            to="/percentage-calculator/$calc"
            params={{ calc: c.slug }}
            className={linkClass}
          >
            <span aria-hidden className={iconChip}>
              {c.icon}
            </span>
            <span>{c.navName()}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
